import React, { useState, useEffect, useMemo } from "react";
import { FaPlus, FaFileContract } from "react-icons/fa";
import { blockchainService } from "../../../../services/blockchainService";
import { criarContract } from "../Actions/CriarContract";
import {
  ListItemDivContract,
  StyledButtonCriarContract,
  StyledButtonVerContrato,
  ModalOverlay,
  ModalContent,
  CloseButton,
  ModalTitle,
  ContractContainer,
  ContractItem,
  ContractLabel,
  ContractValue,
} from "./ProjectContract.style";

const ProjectContract = ({
  projectId,
  modeloId,
  telaName,
  onContractLoaded,
  onDocumentsConfirmed,
}) => {
  const token = sessionStorage.getItem("Authorization");

  const headers = useMemo(
    () => ({
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    }),
    [token]
  );

  const [isDocConfirmed, setIsDocConfirmed] = useState(false);
  const [showContractModal, setShowContractModal] = useState(false);
  const [contract_contract_address_client, setContractAddressClient] = useState("");
  const [contract_contract_address_deploy, setContractAddressDeploy] = useState("");
  const [contract_wallet_owner, setContractWalletOwner] = useState("");
  const [contract_project_name, setContractProjectName] = useState("");
  const [contract_project_owner, setContractProjectOwner] = useState("");
  const [contract_car, setContractCar] = useState("");
  const [contract_cnpj_cpf, setContractCnpjCpf] = useState("");

  useEffect(() => {
    if (contract_contract_address_client) {
      onContractLoaded?.(contract_contract_address_client);
    }
  }, [contract_contract_address_client]);

  /* verifica se docs estão confirmados e carrega dados do contrato */
  useEffect(() => {
    async function loadContractInfo() {
      try {
        const response = await blockchainService.checkDocumentsConfirmed(
          projectId,
          modeloId,
          headers
        );

        const confirmed = !!response.is_confirmed;

        setIsDocConfirmed(confirmed);
        onDocumentsConfirmed?.(confirmed);

        // checkDocumentsConfirmed não retorna contrato; buscar via getContractInfo
        try {
          const contractData =
            await blockchainService.getContractInfo(projectId, headers);
          if (contractData?.ContratoClienteAddress) {
            setContractAddressClient(contractData.ContratoClienteAddress || "");
            setContractAddressDeploy(contractData.ContratoAddress || "");
            setContractWalletOwner(contractData.Signer || "");
            setContractProjectName(contractData.ProjectName || "");
            setContractProjectOwner(contractData.ProjectOwner || "");
            setContractCar(
              Array.isArray(contractData.ProjectCAR)
                ? contractData.ProjectCAR
                : contractData.ProjectCAR || ""
            );
            setContractCnpjCpf(contractData.ProjectCnpjCpf || "");

          }
        } catch (_) {
          // Projeto ainda sem contrato; mantém estado vazio
        }
      } catch (err) {
        console.error("Erro ao carregar contrato", err);
      }
    }

    loadContractInfo();
  }, [projectId, modeloId, headers]);

  /* handler botão criar */
  const handleCriarContrato = async () => {
    await criarContract(
      projectId, // project_id
      modeloId,  // modelo_GUID
      () => { },  // setData2 (caso não use aqui)
      projectId,
      () => { },  // setFileManagerContract
      setContractAddressDeploy,
      setContractAddressClient,
      setContractWalletOwner,
      setContractProjectName,
      setContractProjectOwner,
      setContractCar,
      setContractCnpjCpf
    );
  };

  return (
    <div>
      {isDocConfirmed && (
        <div>
          <ListItemDivContract>
            {!contract_contract_address_client ? (
              <StyledButtonCriarContract onClick={handleCriarContrato}>
                <FaPlus /> Criar Contract
              </StyledButtonCriarContract>
            ) : (
              <StyledButtonVerContrato
                onClick={() => setShowContractModal(true)}
              >
                <FaFileContract /> Exibir Contrato
              </StyledButtonVerContrato>
            )}
          </ListItemDivContract>

          {showContractModal && (
            <ModalOverlay>
              <ModalContent>
                <CloseButton onClick={() => setShowContractModal(false)}>
                  ×
                </CloseButton>

                <ModalTitle>Informações do Contrato</ModalTitle>

                <ContractContainer>
                  <ContractItem>
                    <ContractLabel>Projeto:</ContractLabel>
                    <ContractValue>{contract_project_name}</ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>Responsável:</ContractLabel>
                    <ContractValue>{contract_project_owner}</ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>CNPJ/CPF:</ContractLabel>
                    <ContractValue>{contract_cnpj_cpf}</ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>CAR:</ContractLabel>
                    <ContractValue>{contract_car}</ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>Contrato (Deploy):</ContractLabel>
                    <ContractValue>
                      {contract_contract_address_deploy}
                    </ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>Contrato (Cliente):</ContractLabel>
                    <ContractValue>
                      {contract_contract_address_client}
                    </ContractValue>
                  </ContractItem>

                  <ContractItem>
                    <ContractLabel>Carteira:</ContractLabel>
                    <ContractValue>{contract_wallet_owner}</ContractValue>
                  </ContractItem>
                </ContractContainer>
              </ModalContent>
            </ModalOverlay>
          )}
        </div>
      )}
    </div>
  );
};

export default ProjectContract;